import { Injectable } from "@angular/core";
import { FilterAdapterRegistry } from "../adapters/registry/filter-adapter.registry";
import { FilterBuildOptions } from "../models/filter-build-options.model";
import { FilterConfig } from "../models/filter-config";

@Injectable({
  providedIn: 'root'
})
export class FilterEngineService {
  constructor(
    private readonly addapterRegistry: FilterAdapterRegistry
  ){}

  /**
   * Construcción de la configuracion
   */
  public build (
    options: FilterBuildOptions
  ): FilterConfig {
    const adapter = this.addapterRegistry.resolve(options.filter);
    const filterOptions = adapter.adapt(options.data);
    adapter.adaptConsolidado(options.textoConsolidado, options.consolidado);
    adapter.adaptBusqueda(options.searchable);
    const defaults = adapter.defaults;

    return {
      id: options.id,
      title: options.title,
      type: adapter['type'],
      options: filterOptions,
      multiple: options.multiple ?? defaults.multiple,
      display: options.display,
      removableChips: options.removableChips ?? defaults.removableChips,
      visible: options.visible ?? defaults.visible,
      disabled: options.disabled ?? defaults.disabled,
      searchable: defaults.searchable,
      consolidado: defaults.consolidado,
      textoConsolidado: defaults.textoConsolidado,
    }
  }
}